import { render, staticRenderFns } from "./LinkSocial.vue?vue&type=template&id=7774a27b&scoped=true&"
import script from "./LinkSocial.vue?vue&type=script&lang=js&"
export * from "./LinkSocial.vue?vue&type=script&lang=js&"
import style0 from "./LinkSocial.vue?vue&type=style&index=0&id=7774a27b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7774a27b",
  null
  
)

export default component.exports